// crewbit-admin/src/components/schedule/RecurringBadge.tsx
//
// Schedule Module Phase C C3 — recurring-entry indicator. Body parallel to
// mobile crewbit-mobile/components/schedule/RecurringBadge.tsx modulo runtime.
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §11 + §C.2.

import { Repeat } from 'lucide-react';
import { palette } from '../../styles/tokens';

export interface RecurringBadgeProps {
  size?: number;
  color?: string;
}

export function RecurringBadge({ size = 12, color = palette.g500 }: RecurringBadgeProps) {
  return <Repeat size={size} color={color} aria-label="Recurring" data-testid="recurring-badge" />;
}
